import { useLoading } from '../context/LoadingContext';

export function useApi() {
  const { showLoading, hideLoading } = useLoading();

  const callApi = async (apiFunction, ...params) => {
    try {
      showLoading();
      const result = await apiFunction(...params);
      return result;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    } finally {
      hideLoading();
    }
  };

  return { callApi };
}
